// @todo: Migrate to 'Tabs' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import * as Tabs from '@wandb/weave/components/Tabs';
import React, {useState} from 'react';

import type * as Types from '../../../state/runs/types';
import {type Line} from '../../../util/plotHelpers';
import type * as QueryTypes from '../../../util/queryTypes';
import {EditDataTab} from '../../PanelRunsLinePlot/EditPanelTabs/EditDataTab';
import {EditDisplayPreferencesTab} from '../../PanelRunsLinePlot/EditPanelTabs/EditDisplayPreferencesTab';
import {EditExpressionsTab} from '../../PanelRunsLinePlot/EditPanelTabs/EditExpressionsTab';
import {EditGroupingTab} from '../../PanelRunsLinePlot/EditPanelTabs/EditGroupingTab';
import {PanelInteractionProvider} from '../../PanelRunsLinePlot/PanelInteractionContext';
import {type RunsLinePlotConfig} from '../../PanelRunsLinePlot/types';
import {SettingsContentWrapper} from '../../WorkspaceDrawer/Settings/components/SettingsContentWrapper';
import {WorkspaceDrawerScroller} from '../WorkspaceDrawerScroller';

interface PanelEditorDrawerProps {
  config: RunsLinePlotConfig;
  updateConfig: (config: RunsLinePlotConfig) => void;
  pageQuery: QueryTypes.Query;
  data: Types.Data;
  lines: Line[];
  query: Types.QueryConfig;
}

export const PanelEditorDrawerContent = ({
  config,
  updateConfig,
  pageQuery,
  data,
  lines,
  query,
}: PanelEditorDrawerProps) => {
  const [selectedTab, setSelectedTab] = useState<string | undefined>('Data');

  const header = (
    <span className="pl-4 text-sm font-semibold text-moon-500 uppercase">
      Panel settings
    </span>
  );

  const tabs = [
    {
      title: 'Data',
      content: (
        <PanelInteractionProvider activeRunLimit={config.limit}>
          <div className="mt-24">
            <EditDataTab
              config={config}
              updateConfig={updateConfig}
              lines={lines}
              query={query}
            />
          </div>
        </PanelInteractionProvider>
      ),
    },
    {
      title: 'Grouping',
      content: (
        <EditGroupingTab
          config={config}
          updateConfig={updateConfig}
          pageQuery={pageQuery}
          data={data}
        />
      ),
    },
    {
      title: 'Display preferences',
      content: (
        <EditDisplayPreferencesTab
          config={config}
          updateConfig={updateConfig}
          pageQuery={pageQuery}
          lines={lines}
        />
      ),
    },
    {
      title: 'Expressions',
      content: (
        <EditExpressionsTab config={config} updateConfig={updateConfig} />
      ),
    },
  ];

  return (
    <WorkspaceDrawerScroller>
      <SettingsContentWrapper header={header} title="Line plot">
        <Tabs.Root value={selectedTab ?? ''} onValueChange={setSelectedTab}>
          <Tabs.List>
            {tabs.map(({title}) => (
              <Tabs.Trigger key={title} data-test={title} value={title}>
                {title}
              </Tabs.Trigger>
            ))}
          </Tabs.List>
          {selectedTab != null && (
            <Tabs.Content value={selectedTab}>
              <div data-test="panel-settings-drawer-content">
                {tabs.find(tab => tab.title === selectedTab)?.content}
              </div>
            </Tabs.Content>
          )}
        </Tabs.Root>
      </SettingsContentWrapper>
    </WorkspaceDrawerScroller>
  );
};
